import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Heading, useResponsive } from '@common-fe/common-fe';

import { useExpensesStatisticsQuery } from '@/modules/transaction/hooks/useExpensesStatistics.query';

import TransactionsList from '../TransactionsList';

import { Wrapper } from './ActivityDetails.styles';
import ActivityDetailsExpenses from './ActivityDetailsExpenses';

const ActivityDetails = () => {
  const { t } = useTranslation();

  const { formatedData } = useExpensesStatisticsQuery();

  const { isMobile } = useResponsive();

  return (
    <Box pad={{ bottom: 'spacing24' }}>
      <Wrapper data-testid="ExpenseDetails-wrapper">
        <Box direction="row" margin={{ bottom: 'spacing24', horizontal: isMobile ? 'spacing16' : '' }}>
          <Heading level={1} color="textTitle" size="regular">
            {t('Expense Details')}
          </Heading>
        </Box>
        <ActivityDetailsExpenses
          expensesOptions={formatedData?.expenses || []}
          totalExpense={formatedData?.totalExpenses || 0}
        />
        <TransactionsList />
      </Wrapper>
    </Box>
  );
};
export default ActivityDetails;
